import { useQuery, UseQueryResult } from 'react-query';
import { CompanyDocuments } from '../../models/CompanyDocuments';
import { SearchLoanDto } from '../../services/dtos/securities/searchLoans.dto';
import { LoansSortOption } from '../../services/securities/securities.constants';
import { fetchLoans } from '../../services/securities/securities.service';
import { queryKeys } from '../queryKeyFactory';
import { fetchAllDocuments } from './utils/fetchAllDocuments';
import { groupDocuments } from './utils/groupDocuments';

export type SearchSecuritiesFilterValue = Record<string, Record<string, unknown>>;
export interface SearchLoansPayload {
  filters?: SearchSecuritiesFilterValue;
  sort?: LoansSortOption;
  sortDesc?: boolean;
  skip?: number;
  take?: number;
}

export default (
  companyId: string,
  payload: SearchLoansPayload,
  enabled = true
): UseQueryResult<CompanyDocuments<SearchLoanDto>, Error> => {
  return useQuery<CompanyDocuments<SearchLoanDto>, Error>(
    queryKeys.fetchLoans.allByIssuer(companyId, payload, enabled),
    async () => {
      const { totalResults, results } = await fetchAllDocuments<SearchLoanDto, SearchLoansPayload>(fetchLoans, payload);
      const groupedLoans = groupDocuments(results);

      return { totalResults, results: groupedLoans };
    },
    { enabled: enabled && !Number.isNaN(Number(companyId)), retry: false }
  );
};
